import { render, staticRenderFns } from "./ClaioImagePreview.vue?vue&type=template&id=2dcc79bc&scoped=true&"
import script from "./ClaioImagePreview.vue?vue&type=script&lang=ts&"
export * from "./ClaioImagePreview.vue?vue&type=script&lang=ts&"
import style0 from "./ClaioImagePreview.vue?vue&type=style&index=0&id=2dcc79bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcc79bc",
  null
  
)

export default component.exports